import React, { useEffect, useState } from "react";
import {
  Table,
  Divider,
  PageHeader,
  Button,
  Form,
  Select,
  Input,
  message,
  Modal,
  Segmented,
  Radio,
  Checkbox,
  DatePicker,
} from "antd";
import {
  FlexRowContainer,
  FlexRowEndContainer,
  FlexRowQuarterContainer,
  FlexRowReverseContainer,
} from "../../Common/Container.styles";

import { useNavigate } from "react-router-dom";
import {CheckOutlined, CloseOutlined, SearchOutlined} from "@ant-design/icons";

import * as userAPI from "../../../api/user";
import * as fileAPI from "../../../api/file";

import {
  dateToCompactString,
  dateToString,
  numberWithCommas,
} from "../../../util/common";

import Pagination from "react-js-pagination";
import { Option } from "antd/lib/mentions";
import { useRecoilState } from "recoil";
import { searchItemState } from "../../../states/atoms";
import TextArea from "antd/lib/input/TextArea";
import {createUserGroups, getUserGroups} from "../../../api/user";
import * as orderAPI from "../../../api/order";

export default function UserList() {
  const [searchItem, setSearchItem] = useRecoilState(searchItemState);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [current, setCurrent] = useState(
    Number(sessionStorage.getItem("page")) ?? 1
  );
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState("전체");

  const [startCreatedDate, setStartCreatedDate] = useState(null);
  const [endCreatedDate, setEndCreatedDate] = useState(null);

  const [showRefundModal, setShowRefundModal] = useState(false);
  const [targetUser, setTargetUser] = useState(null);

  const [group, setGroup] = useState(null)

  const [groups, setGroups] = useState([])

  const [groupModalVisible, setGroupModalVisible] = useState(false);

  const [groupForm] = Form.useForm();
  const [groupName, setGroupName] = useState('')

  const onChangeFilter = (newFilter) => {
    setFilter(newFilter);
    onChange(1);
  };

  const onChange = (page) => {
    setCurrent(page);
    sessionStorage.setItem("page", page);
  };

  const [form] = Form.useForm();
  const [dateForm] = Form.useForm();

  const searchQuery = Form.useWatch("searchQuery", form);
  const searchKeyword = Form.useWatch("searchKeyword", form);
  const status = Form.useWatch("status", form);
  const size = Form.useWatch("size", form);
  const grade = Form.useWatch("grade", form);
  const isExpert = Form.useWatch("isExpert", form);

  const fetchUsers = () => {
    const request = {
      page: current,
      size: size ?? 50,
      startCreatedDate,
      endCreatedDate,
      status,
      isExpert,
      group: group?.isGrade ? group?.name : group?.id,
      grade
    };
    request[`${searchQuery}`] = searchKeyword;
    request[`${searchItem.searchQuery}`] = searchItem.searchKeyword;

    userAPI.getUsers(request).then((res) => {
      if (res.data.linusCode === 1) {
        setTotal(res.data.page.count);
        setUsers(
          res.data.data?.map((r) => {
            return {
              ...r,
              key: r.id,
              regTime: dateToString(r.regTime),
              last_login: dateToString(r.last_login),
            };
          })
        );
        setLoading(false);
      } else {
        alert(res.data.data.msg);
      }
    });
  };

  useEffect(() => {
    if (current !== 1) {
      setCurrent(1);
      return;
    }

    setLoading(true);
    fetchUsers();
  }, [filter, startCreatedDate, endCreatedDate, status, isExpert, size, group, grade, searchItem]);

  useEffect(() => {
    setLoading(true);
    fetchUsers();
  }, [current]);

  const onSearch = (e) => {
    if (!searchQuery) {
      message.error("검색조건을 선택해주세요.");
      return;
    }

    if (!searchKeyword) {
      message.error("검색 키워드를 입력해주세요.");
      return;
    }

    const newSearchItem = {
      ...searchItem,
      searchQuery: searchQuery,
      searchKeyword: searchKeyword,
    };
    setSearchItem(newSearchItem);

    setCurrent(1);
    sessionStorage.setItem("page", 1);

    setLoading(true);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedItems(selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  const [memoForm] = Form.useForm();
  const [memo, setMemo] = useState({});
  const [showMemoModal, setShowMemoModal] = useState(false);

  const onFinishMemoModal = (values) => {
    userAPI
      .editUser({
        ...memo,
        ...values,
      })
      .then((res) => {
        if (res.data.linusCode === 1) {
          message.success("메모 입력이 완료되었습니다.");
          setShowMemoModal(false);
          fetchUsers();
        } else {
          alert(res.data.data.msg);
        }
      })
      .catch((error) => {
        if (error.response.data.detail) {
          message.error(error.response.data.detail);
        } else if (error.response.status < 500) {
          for (let key of Object.keys(error.response.data)) {
            message.error(`${key}: ${error.response.data[key]}`);
          }
        } else {
          message.error("오류가 발생했습니다.");
        }
      });
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "회원 타입 구분",
      dataIndex: "isExpert",
      render: (val) => {
        return val ? '전문가' : '일반회원';
      },
    },
    {
      title: "이름",
      dataIndex: "name",
      width: "5%",
      render: (val) => {
        return val;
      },
    },
    {
      title: "연락처",
      render: (val) => {
        return (
          <div>
            <div
              style={{
                fontSize: "13px",
              }}
            >
              {val.email}
            </div>
            <div
              style={{
                fontSize: "12px",
              }}
            >
              {val.phone}
            </div>
          </div>
        );
      },
    },
    {
      title: "생년 월일",
      dataIndex: "birth",
      width: "8%",
      render: (val) => {
        return val;
      },
    },
    {
      title: "성별",
      dataIndex: "gender",
      width: "8%",
      render: (val) => {
        return val;
      },
    },
    {
      title: "수신 이메일",
      dataIndex: "receiptEmail",
      width: "8%",
      render: (val) => {
        return val;
      },
    },
    {
      title: "가입일",
      dataIndex: "date_joined",
      width: "12%",
      render: (val) => {
        return dateToString(val);
      },
    },
  ];

  const searchQueries = [
    {
      title: "이름",
      dataIndex: "name",
    },
    {
      title: "휴대전화",
      dataIndex: "phone",
    },
    {
      title: "이메일",
      dataIndex: "email",
    },
    {
      title: "성별",
      dataIndex: "gender",
    },
    {
      title: "수신이메일",
      dataIndex: "receiptEmail",
    },
    {
      title: "가입일",
      dataIndex: "createdDate",
    },
  ];

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const onDelete = (e) => {
    e.preventDefault();
    if (selectedItems.length === 0) {
      message.error("선택된 항목이 없습니다.");
      return;
    }
    setLoading(true);
    userAPI
      .deleteUsers({ selectedItems: selectedItems?.map((i) => i.id) })
      .then((res) => {
        if (res.data.linusCode === 1) {
          fetchUsers();
          setSelectedItems([]);
          message.success("성공적으로 삭제되었습니다.");
          setDeleteModalVisible(false);
        } else {
          alert(res.data.data.msg);
        }
      });
  };

  const onShowDeleteModal = (e) => {
    e.preventDefault();
    setDeleteModalVisible(true);
  };

  const onEdit = (newStatus) => {
    if (selectedItems.length !== 1) {
      message.error("하나의 항목을 선택 후 수정 버튼을 눌러주세요.");
      return;
    }

    navigate(`/user/user/edit/${selectedItems[0]?.id}`);
  };

  const [refundForm] = Form.useForm();
  const [refund, setRefund] = useState({});
  const user = Form.useWatch("user", refundForm);
  const [showPushModal, setShowPushModal] = useState(false);

  const onShowPushModal = (e) => {
    e.preventDefault();

    if (selectedItems.length !== 1) {
      message.error("하나의 항목을 선택 후 수정 버튼을 눌러주세요.");
      return;
    }

    setShowPushModal(true);
  };

  const onGroupFinish = () => {
    userAPI.createUserGroups({name: groupName, isGrade: groupForm.getFieldValue('isGrade')}).then(res => {
      if (res?.data?.linusCode === 1) {
        message.success('올바르게 등록되었습니다.')
        setGroupModalVisible(false)
      }
    }).catch((error) => {
      if (error.response.data.detail) {
        message.error(error.response.data.detail);
      } else if (error.response.status < 500) {
        for (let key of Object.keys(error.response.data)) {
          message.error(`${key}: ${error.response.data[key]}`);
        }
      } else {
        message.error("오류가 발생했습니다.");
      }
    });
  }

  const editGroups = (groups) => {
    let requests = selectedItems?.map((i) => {
      return userAPI.editUser({
        id: i.id,
        groups,
      });
    });

    Promise.all(requests)
      .then((res) => {
        fetchUsers();
        message.success("변경이 완료되었습니다.");
      })
      .catch((error) => {
        if (error?.response?.data?.data?.msg) {
          alert(error.response.data.data.msg);
        }
      });
  }

  const editGrades = (grade) => {
    let requests = selectedItems?.map((i) => {
      return userAPI.editUser({
        id: i.id,
        grade,
      });
    });

    Promise.all(requests)
      .then((res) => {
        fetchUsers();
        message.success("변경이 완료되었습니다.");
      })
      .catch((error) => {
        if (error?.response?.data?.data?.msg) {
          alert(error.response.data.data.msg);
        }
      });
  }

  const [showGroupModal, setShowGroupModal] = useState(false);

  return (
    <div>
      <Modal
        width={400}
        title="삭제 확인"
        visible={deleteModalVisible}
        onOk={onDelete}
        onCancel={() => {
          setDeleteModalVisible(false);
        }}
        footer={[
          <Button
            key="back"
            onClick={(e) => {
              e.preventDefault();
              setDeleteModalVisible(false);
            }}
          >
            취소
          </Button>,
          <Button key="submit" type="primary" danger onClick={onDelete}>
            삭제
          </Button>
        ]}
      >
        선택한 항목을 삭제하시겠습니까?
      </Modal>
      <Modal
        width={400}
        title="그룹 추가"
        visible={groupModalVisible}
        onOk={onGroupFinish}
        onCancel={() => {
          setGroupModalVisible(false);
        }}
      >
        <Form
          form={groupForm}
          name="group-register"
          onFinish={onGroupFinish}
          scrollToFirstError
          style={{ width: "50%" }}
        >
          <Form.Item
            name="isGrade"
            label="그룹 유형"
            initialValue={false}
          >
            <Select>
              <Select.Option value={false}>일반 유형</Select.Option>
              <Select.Option value={true}>등급 유형</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="name"
            label="그룹명"
          >
            <Input placeholder={'그룹명'} onChange={e => setGroupName(e.target.value)}/>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        width={400}
        title="메모"
        visible={showMemoModal}
        onOk={onFinishMemoModal}
        onCancel={() => {
          setShowMemoModal(false);
        }}
        footer={[]}
      >
        <Form
          form={memoForm}
          name="memo"
          onFinish={onFinishMemoModal}
          initialValues={memo}
          scrollToFirstError
        >
          <Form.Item
            name="memo"
            label="메모"
            rules={[
              {
                required: true,
                message: "내용을 입력해주세요.",
              },
            ]}
          >
            <TextArea />
          </Form.Item>

          <Form.Item>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                onClick={(e) => {
                  setShowMemoModal(false);
                }}
                style={{ margin: "0 10px" }}
              >
                목록
              </Button>
              <Button type="primary" htmlType="submit">
                저장
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        width={400}
        title="그룹 설정"
        visible={showGroupModal}
        onOk={() => {setShowGroupModal(false)}}
        onCancel={() => {
          setShowGroupModal(false);
        }}
        footer={[]}
      >
        <Checkbox.Group placeholder="그룹 변경" onChange={values => {
            if (window.confirm('선택한 유저들의 그룹을 변경하시겠습니까?')) {
              editGroups(values)
            }
          }}
            options={groups?.map(item => {
                return {
                  label: item?.name,
                  value: item?.id
                }})}
          />
      </Modal>
      <div style={{flex: 5}}>
        <PageHeader
          className="site-page-header"
          title="사용자 목록"
          subTitle={`총 ${total}명의 사용자가 존재합니다.`}
        />
        <Form form={form} onFinish={onSearch}>
          <FlexRowContainer style={{ marginTop: "10px" }}>
            <FlexRowQuarterContainer>
              <Form.Item name="searchQuery" initialValue={searchItem.searchQuery}>
                <Select placeholder="검색조건">
                  {searchQueries?.map((c) => {
                    return (
                      <Select.Option key={c.dataIndex} value={c.dataIndex}>
                        {c.title}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item
                name="searchKeyword"
                initialValue={searchItem.searchKeyword}
              >
                <Input placeholder="검색 키워드를 입력하세요" />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  htmlType="submit"
                />
              </Form.Item>
            </FlexRowQuarterContainer>
          </FlexRowContainer>
          <FlexRowContainer>
            <Form.Item name="isExpert" style={{ width: "300px" }}>
              <Select placeholder="회원 타입 구분">
                {[
                  { label: "전체", value: null },
                  { label: "전문가", value: true },
                  { label: "일반 회원", value: false },
                ].map((c) => {
                  return (
                    <Select.Option key={c.label} value={c.value}>
                      {c.label}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
          </FlexRowContainer>
          <FlexRowContainer style={{ marginTop: "30px" }}>
            <Button
              type="primary"
              onClick={(e) => {
                e.preventDefault();
                const newSearchItem = {
                  ...searchItem,
                  searchQuery: null,
                  searchKeyword: null,
                };
                setSearchItem(newSearchItem);

                setCurrent(1);
                sessionStorage.setItem("page", 1);
                setFilter("전체");
                setGroup(null)
                setStartCreatedDate(null);
                setEndCreatedDate(null);
                form.setFieldValue("searchQuery", null);
                form.setFieldValue("searchKeyword", null);
                form.setFieldValue('grade', null)
              }}
            >
              검색 조건 초기화
            </Button>
          </FlexRowContainer>
          <FlexRowReverseContainer>
            <FlexRowQuarterContainer>
              <Form.Item name="size" style={{ width: "300px" }}>
                <Select placeholder="표시 개수 선택">
                  {[
                    { label: "50개씩 보기", value: 50 },
                    { label: "100개씩 보기", value: 100 },
                    { label: "200개씩 보기", value: 200 },
                    { label: "300개씩 보기", value: 300 },
                    { label: "400개씩 보기", value: 400 },
                    { label: "500개씩 보기", value: 500 },
                  ].map((c) => {
                    return (
                      <Select.Option key={c.label} value={c.value}>
                        {c.label}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </FlexRowQuarterContainer>
          </FlexRowReverseContainer>
        </Form>
        <Divider />
        <Table
          pagination={false}
          loading={loading}
          columns={columns}
          dataSource={users}
          rowSelection={{
            type: "checkbox",
            ...rowSelection,
          }}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                navigate(`/user/user/edit/${record.id}`);
              }, // click row
              onDoubleClick: (event) => {}, // double click row
              onContextMenu: (event) => {}, // right button click row
              onMouseEnter: (event) => {}, // mouse enter row
              onMouseLeave: (event) => {}, // mouse leave row
            };
          }}
          style={{ cursor: "pointer" }}
        />
        <FlexRowEndContainer style={{ marginTop: "30px" }}>
          <Pagination
            activePage={current}
            itemsCountPerPage={size ?? 50}
            totalItemsCount={total}
            pageRangeDisplayed={10}
            onChange={onChange}
          />
        </FlexRowEndContainer>
      </div>
    </div>
  );
}
